import {defaultTheme} from '../theme/variants';
import {ThemeColorKeys} from '../types';

export function getThemeColor(key: ThemeColorKeys) {
	return defaultTheme.colors[key].value;
}
